// src/config.js
let apiBaseUrl;

// Detecta si es dev o prod
if (process.env.NODE_ENV === "development") {
  // Desarrollo
  apiBaseUrl = "http://localhost:8080/api/v1";
} else {
  // Producción
  apiBaseUrl = "/api/v1";
}

export default {
  apiBaseUrl
};
